import { BubbleMenu as BaseBubbleMenu } from "@tiptap/react";
import React, { useCallback } from "react";
import { sticky } from "tippy.js";
import { v4 as uuid } from "uuid";

import { EditIframeLinkPopover } from "../../../features/menus/TextMenu/components/EditIframeLinkPopover.js";
import { MenuProps } from "../../../features/menus/types.js";
import { Toolbar } from "../../../features/ui/Toolbar.js";
import { getRenderContainer } from "../../../lib/utils/index.js";
import i18next from "i18next";

export const IframeMenu = ({ editor, appendTo }: MenuProps) => {
  const getReferenceClientRect = useCallback(() => {
    const renderContainer = getRenderContainer(editor, "iframe");
    const rect =
      renderContainer?.getBoundingClientRect() ||
      new DOMRect(-1000, -1000, 0, 0);

    return rect;
  }, [editor]);

  const shouldShow = useCallback(() => {
    const isIframe = editor.isActive("iframe");
    return isIframe;
  }, [editor]);

  const onSetLink = useCallback(
    (src: string) => editor.chain().focus().setIframe({ src: src }).run(),
    [editor]
  );
  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey={`iframeMenu`}
      shouldShow={shouldShow}
      tippyOptions={{ popperOptions: { placement: "top-start" } }}
      updateDelay={100}
    >
      <Toolbar.Wrapper>
        <Toolbar.Button
          type="button"
          tooltip={i18next.t("iframe Link") || "iframe"}
          active={true}
          // onClick={onColumnLeft}
        >
          <EditIframeLinkPopover
            onSetLink={onSetLink}
            initialSrcLink={editor?.getAttributes("iframe")?.editorValue ?? ""}
          />
        </Toolbar.Button>
      </Toolbar.Wrapper>
    </BaseBubbleMenu>
  );
};

export default IframeMenu;
